const initialState = {
    federations: [],
    loading: false,
    error: null,
    lastFetched: null
};

const FederationsReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'FETCH_FEDERATIONS_REQUEST':
            return {
                ...state,
                loading: true,
                error: null
            };
        
        case 'FETCH_FEDERATIONS_SUCCESS':
            return {
                ...state,
                loading: false,
                federations: action.payload,
                lastFetched: Date.now(),
                error: null
            };
        
        case 'FETCH_FEDERATIONS_FAILURE':
            return {
                ...state,
                loading: false,
                error: action.payload,
                federations: []
            };
        
        case 'CLEAR_FEDERATIONS':
            return {
                ...state,
                federations: [],
                error: null,
                lastFetched: null
            };
        
        default:
            return state;
    }
};

export default FederationsReducer;